import React, { useState, useEffect, useCallback } from 'react';
import { 
  FaInfoCircle, 
  FaCheckCircle, 
  FaExclamationTriangle, 
  FaExclamationCircle
} from 'react-icons/fa';

/**
 * 消息提示组件
 * @param {string} type - 提示类型: 'info'|'success'|'warning'|'danger'
 * @param {string} message - 提示信息内容
 * @param {boolean} dismissible - 是否可关闭
 * @param {function} onClose - 关闭回调函数
 * @param {number} autoHideDuration - 自动隐藏时间(毫秒)，为0时不自动隐藏
 * @param {string} className - 额外的CSS类名
 */
const Alert = ({
  type = 'info',
  message,
  dismissible = false,
  onClose,
  autoHideDuration = 0,
  className = '',
}) => {
  const [visible, setVisible] = useState(true);

  // 处理关闭事件 - 使用useCallback优化
  const handleClose = useCallback(() => {
    setVisible(false);
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  // 处理自动隐藏
  useEffect(() => {
    if (autoHideDuration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, autoHideDuration);
      
      return () => clearTimeout(timer);
    }
  }, [autoHideDuration, handleClose]);

  // 如果不可见，则不渲染
  if (!visible) {
    return null;
  }

  // 根据类型获取图标
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className="me-2" />;
      case 'warning':
        return <FaExclamationTriangle className="me-2" />;
      case 'danger':
        return <FaExclamationCircle className="me-2" />;
      case 'info':
      default:
        return <FaInfoCircle className="me-2" />;
    }
  };

  return (
    <div 
      className={`alert alert-${type} d-flex align-items-center ${dismissible ? 'alert-dismissible' : ''} ${className}`} 
      role="alert"
    >
      {getIcon()}
      <div>{message}</div>
      
      {dismissible && (
        <button 
          type="button" 
          className="btn-close" 
          onClick={handleClose} 
          aria-label="关闭"
        ></button>
      )}
    </div>
  );
};

export default Alert; 